<template>
  <section>
    <el-page-header @back="goBack" content="SKU权益项设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeGrouping" type="card" @tab-click="handleGroupClick">
      <el-tab-pane :key="index" v-for="(item,index) in groupedList" :label="item.name"
                   :name="item.id + ''"></el-tab-pane>
    </el-tabs>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              size="mini"
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchDictionaryList"
          ></el-input>
          <el-select size="mini" v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
                v-for="item in COMMON_STATUS"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="mini" type="primary" @click="SearchDictionaryList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="goToScheme"
          >方案管理
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="标题" min-width="150">
            </el-table-column>
            <el-table-column prop="logo" label="图片" width="100">
              <template slot-scope="scope">
                <el-image :src="scope.row.logo" style="max-width: 50px;max-height: 50px"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="payPrice" label="价格" width="100">
              <template slot-scope="scope">
                {{ `$ ${formatMinNum(scope.row.payPrice)}` }}
              </template>
            </el-table-column>
            <el-table-column prop="content" label="内容" min-width="150">
            </el-table-column>
            <el-table-column
                align="center"
                prop="sort"
                label="排序"
                width="80"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="text"
                    placeholder="输入排序数据"
                    v-model="scope.row.sort"
                    @blur="changOrdered(scope.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-switch
                    size="mini"
                    :disabled="statusShow"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeSwitch(scope.row)"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="200">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('exam', scope.row)"
                    plain
                    type="warning"
                    v-if="scope.row.categoryType == 2"
                    size="mini"
                >关联测评
                </el-button
                >
                <el-button
                    @click="handleClick('course', scope.row)"
                    plain
                    type="warning"
                    v-if="scope.row.categoryType == 3"
                    size="mini"
                >关联课程
                </el-button
                >
                <el-button
                    @click="handleClick('vip', scope.row)"
                    plain
                    type="warning"
                    v-if="scope.row.categoryType == 4"
                    size="mini"
                >关联会员
                </el-button
                >
                <el-button
                    @click="handleClick('coupon', scope.row)"
                    plain
                    type="warning"
                    v-if="scope.row.categoryType == 5"
                    size="mini"
                >关联券组
                </el-button
                >
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    type="primary"
                    v-if="editShow"
                    size="mini"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="danger"
                    plain
                    size="mini"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑/新增SKU权益"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="780px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <el-form-item label="标题：" prop="name">
            <el-input
                clearable
                placeholder="请填写权益标题"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="移动：">
                <upLoadImg
                    :keyWord="'logo'"
                    :params="params"
                    v-if="flag"
                ></upLoadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="item" label="PC：">
                <upLoadImg
                    :keyWord="'logoPc'"
                    :params="params"
                    v-if="flag"
                ></upLoadImg>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="等级：" prop="payPrice">
            <el-select v-model="params.level" placeholder="请选择等级">
              <el-option v-for="item in levelList" :key="item.value"
                         :label="item.label" :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格($)：" prop="payPrice">
            <el-input
                clearable
                placeholder="请填写权益价格"
                v-model="params.payPrice"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input
                clearable
                placeholder="请填写权益排序"
                v-model="params.sort"
            ></el-input>
          </el-form-item>
          <el-form-item label="结果页：">
            <el-select v-model="params.resultPageCode">
              <el-option v-for="item in reportList" :key="item.item" :label="item.value" :value="item.item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述：" prop="content">
            <el-input
                clearable
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写描述"
                v-model="params.content"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 测评题数据 -->
    <el-dialog
        title="测评题列表"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div style="display: flex;align-items: center;margin-bottom: 20px">
          <div class="item-son" style="margin-right: 20px">
            <el-input
                style="width: 200px"
                v-model="listParams.searchKey"
                placeholder="搜索关键词"
                clearable
                @keyup.enter.native="queryTestTableData"
            ></el-input>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="queryTestTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="multipleTableTest"
              size="medium"
              :data="allTestTableData"
              border
              height="60vh"
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="100" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="题目" width="100" align="center">
              <template slot-scope="scope">
                <span>维度：{{ scope.row.dimensions }} <br> 题目：{{ scope.row.questions }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="支付价" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ `$ ${formatMinNum(scope.row.payPrice)}` }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="数量" width="160" align="center">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.count" :min="1" label="描述文字"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="innerVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleTopicList"
        >确 定</el-button
        >
      </span>
      </div>
    </el-dialog>
    <!-- 会员数据 -->
    <el-dialog
        title="会员列表"
        :visible.sync="vipInnerVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="singleTable"
              size="medium"
              :data="vipInfoList"
              border
              highlight-current-row
              @current-change="handleCurrentChange"
              style="width: 100%"
          >
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center" width="150">
            </el-table-column>
            <el-table-column prop="payPrice" label="价格" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ `$ ${formatMinNum(scope.row.payPrice)}` }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="时间" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.days }}天</span>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="权益" align="left">
              <template slot-scope="scope">
                <template v-if="scope.row.vipItems.length">
                  <img class="cute_img_box" :src="item.icon" :key="index" v-for="(item,index) in scope.row.vipItems">
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="vipInnerVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleVipList"
        >确 定</el-button
        >
      </span>
      </div>
    </el-dialog>
    <!--券事件绑定-->
    <el-dialog
        title="关联券组"
        :visible.sync="dialogVoucherVisible"
        :close-on-click-modal="false"
        width="520px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="voucherRuleForm"
            :rules="voucherRules"
            :model="voucherParams"
            label-width="80px"
        >
          <el-form-item label="券事件：" prop="eventIds">
            <el-select
                v-model="voucherParams.eventIds"
                clearable
                multiple
                placeholder="请选择券事件"
                filterable
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in vipRightTonList"
                  :key="`${index}`"
                  :label="`${item.eventName}`"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVoucherVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleVoucherEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 课程数据 -->
    <el-dialog
        title="测评题列表"
        :visible.sync="innerCourseVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div style="display: flex;align-items: center;margin-bottom: 20px">
          <div class="item-son" style="margin-right: 20px">
            <el-input
                style="width: 200px"
                v-model="courseSearchValue"
                placeholder="搜索关键词"
                clearable
                @keyup.enter.native="getCourseList"
            ></el-input>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="getCourseList"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="multipleCourseTableTest"
              size="medium"
              :data="courseList"
              border
              height="60vh"
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="parentCategoryName" label="一级分类" width="100" align="center">
            </el-table-column>
            <el-table-column prop="categoryName" label="二级分类" width="100" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="题目" width="100" align="center">
              <template slot-scope="scope">
                <div>章节：{{ scope.row.chapterCount }}</div>
                <div>页数：{{ scope.row.pageCount }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="categoryName"
                label="数据"
                width="180"
                align="center"
            >
              <template slot-scope="scope">
                <div>学习人数：{{ scope.row.uvCount }}</div>
                <div>学习次数：{{ scope.row.pvCount }}</div>
                <div>购买人数：{{ scope.row.displayPurchaseCount }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="支付价" width="100" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <div style="color: #f56c6c; font-weight: bold; font-size: 14px;">
                    ¥{{ formatPrice(scope.row.discountPrice) }}
                  </div>
                  <div style="color: #999; font-size: 12px; text-decoration: line-through;" v-if="scope.row.originalPrice !== scope.row.discountPrice">
                    ¥{{ formatPrice(scope.row.originalPrice) }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="innerCourseVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleCourseList"
        >确 定</el-button
        >
      </span>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {COMMON_STATUS} from "@/config";
import {ossUpload} from "@utils/filters/upload";
import {formatMinNum} from "@utils/tools/index";
import upLoadImg from "@views/app/components/upLoadImg";
import selectTopic from "@views/app/components/selectTopic";

export default {
  components: {upLoadImg, selectTopic},
  data() {
    return {
      formatMinNum,
      COMMON_STATUS,
      loading: false,
      loading1: false, //加载中
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写权益标题", trigger: "change"},
        ],
        payPrice: [
          {required: true, message: "请填写权益价格", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //二级--列表
      addShow: true,
      deleteShow: true,
      editShow: true,
      statusShow: false,
      searchShow: true,
      detalisObj: {},
      groupedList: [],
      activeGrouping: '',
      flag: false,
      innerVisible: false,
      listParams: {},
      allTestTableData: [],
      checkDataList: [],
      equityData: {},
      vipInfoList: [],
      vipInnerVisible: false,
      dialogVoucherVisible: false,
      voucherParams: {},
      vipRightTonList: [],
      voucherRules: {
        eventIds: [
          {required: true, message: "请选择关联事件", trigger: "change"},
        ],
      },
      courseList: [],
      innerCourseVisible: false,
      courseSearchValue: '',
      languageList: [],
      languageCode: '',
      reportList:[],
      levelList:[
        {
          label: "基础订阅解锁",
          value: 1
        },{
          label: "高级订阅解锁",
          value: 2
        },{
          label: "其他",
          value: 9
        }
      ]
    };
  },
  created() {
    this.getVipRightList();
    this.getAppraisalData();
    this.queryTestTableData();
    this.getVipInfoList()
    this.getVipTonRightList()
    this.getCourseList()
    this.getLanguageList()
    this.getReportList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.flag = false;
      }
    },
  },
  methods: {
    // 格式化价格（美元分转元）
    formatPrice(price) {
      if (!price) return '0.00';
      return (price / 100).toFixed(2);
    },
    handleTabClick() {
      if (this.params.id) {
        this.getEquityInfo()
      }
    },
    ///exam/report/list
    async getReportList() {
      const {data: resData} = await this.$get(
          `exam/report/list?examId=${this.$route.query.examId}`
      );
      if (resData.result != 200) return;
      this.reportList = resData.data
    },
    async getEquityInfo() {
      this.flag = false
      this.loading = true;
      const {data: resData} = await this.$get("/sku/info/"+this.params.id,{
        headers: {
          isLoading: true,
          'Language-Code':this.languageCode
        },
      });
      this.loading = false;
      this.params = JSON.parse(JSON.stringify(resData.data));
      this.params.payPrice = this.params.payPrice / 100
      this.$nextTick(() => {
        this.flag = true;
      });
    },
    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      this.languageCode = res.data[0].code
    },
    changeShowTxt(data) {
      return JSON.parse(data)
    },
    async getCourseList() {
      this.loading = true;
      const {data: resData} = await this.$post("/course/info/list", {
        pageNo: 1,
        pageSize: 100,
        searchValue: this.courseSearchValue
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.courseList = resData.data
    },
    handleCourseList() {
      let temp = [];
      this.checkDataList.map((item) => {
        let obj = {
          categoryId: item.id,
        }
        temp.push(obj);
      });
      this.addTopicList(temp, this.equityData.skuCode);
    },

    goToScheme() {
      this.$router.push({
        name: "SCHEME_GROUPING",
        query: {
          examId: this.$route.query.examId,
        }
      })
    },
    async handleVoucherEdit() {
      let categoryInfosData = []
      this.voucherParams.eventIds.map(item => {
        let obj = {
          categoryId: item
        }
        categoryInfosData.push(obj)
      })
      this.loading = true;
      const {data: resData} = await this.$post("/sku/category/ref/bind", {
        categoryInfos: categoryInfosData,
        skuCode: this.equityData.skuCode,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
      this.dialogVoucherVisible = false;
    },
    async getVipTonRightList() {
      let http = "/coupon/event/list";
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.vipRightTonList = resData.data;
      } else {
        this.vipRightTonList = [];
      }
    },
    //获取会员列表
    async getVipInfoList() {
      let http = "/vip/info/list";
      this.loading = true;
      //组织列表
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.result != 200) return;
      this.vipInfoList = resData.data
    },
    //设置数组选择
    handleSelectionChange(e) {
      this.checkDataList = e
    },
    handleCurrentChange(e) {
      this.checkDataList = []
      this.checkDataList.push(e)
    },
    //获取测评题
    async queryTestTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/list?styleType=cpzy&paging=false", {
        params: {
          ...this.listParams
        }
      });
      this.loading = false;
      if (resData.result != 200) return;
      resData.data.map(item => {
        item.count = 1
      })
      this.allTestTableData = resData.data
    },
    //确定选择的题列表
    handleTopicList() {
      let temp = [];
      this.checkDataList.map((item) => {
        let obj = {
          categoryId: item.examInfoId,
          count: item.count
        }
        temp.push(obj);
      });
      this.addTopicList(temp, this.equityData.skuCode);
    },
    //确定选择的会员列表
    handleVipList() {
      let temp = [];
      this.checkDataList.map((item) => {
        let obj = {
          categoryId: item.code,
        }
        temp.push(obj);
      });
      this.addTopicList(temp, this.equityData.skuCode);
    },
    /**
     * 新增测评题
     */
    async addTopicList(data, skuCode) {
      this.loading = true;
      const {data: resData} = await this.$post("/sku/category/ref/bind", {
        categoryInfos: data,
        skuCode: skuCode,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
      this.innerVisible = false;
      this.vipInnerVisible = false;
      this.innerCourseVisible = false
    },
    //获取绑定是测评题目
    async queryBindList(data, type) {
      this.loading = true;
      const {data: resData} = await this.$get("/sku/category/ref/list/" + data.skuCode);
      this.loading = false;
      if (resData.result != 200) return;
      if (type == 'exam') {
        let checkData = this.getArrDifSameValue(resData.data, this.allTestTableData, type)
        checkData.forEach(row => {
          this.$refs.multipleTableTest.toggleRowSelection(row, true);
        });
      } else if (type == 'vip') {
        let checkData = this.getArrDifSameValue(resData.data, this.vipInfoList, type)
        this.$refs.singleTable.setCurrentRow(checkData[0], true);
      } else if (type == 'course') {
        let checkData = this.getArrDifSameValue(resData.data, this.courseList, type)
        checkData.forEach(row => {
          this.$refs.multipleCourseTableTest.toggleRowSelection(row, true);
        });
      }
    },
    //获取两个相同数组的内容
    getArrDifSameValue(arr1, arr2, type) {
      var result = [];
      for (var i = 0; i < arr2.length; i++) {
        var obj = arr2[i];
        if (type == 'exam') {
          var id = obj.examInfoId;
        } else if (type == 'vip') {
          var id = obj.code;
        } else if (type == 'course') {
          var id = obj.id;
        }
        var isExist = false;
        for (var j = 0; j < arr1.length; j++) {
          var aj = arr1[j];
          var n = aj.categoryId;
          if (n == id) {
            arr2[i].count = arr1[j].count
            isExist = true;
            break;
          }
        }
        if (isExist) {
          result.push(obj);
        }
      }
      return result;
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
        this.getEquityInfo()
      } else if (type == 'addNext') {
        //添加
        this.params = {};
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.flag = true;
        });
      } else if (type == 'exam') {
        this.innerVisible = true
        this.equityData = JSON.parse(JSON.stringify(row));
        this.$nextTick(() => {
          this.queryBindList(row, type)
        })
      } else if (type == 'vip') {
        this.vipInnerVisible = true
        this.equityData = JSON.parse(JSON.stringify(row));
        this.$nextTick(() => {
          this.queryBindList(row, type)
        })
      } else if (type == 'coupon') {
        this.dialogVoucherVisible = true
        this.equityData = JSON.parse(JSON.stringify(row));
        this.$nextTick(() => {
          this.queryBindVoucherList(row)
        })
      } else if (type == 'course') {
        this.innerCourseVisible = true
        this.equityData = JSON.parse(JSON.stringify(row));
        this.$nextTick(() => {
          this.queryBindList(row, type)
        })
      }

    },
    async queryBindVoucherList(data) {
      this.loading = true;
      const {data: resData} = await this.$get("/sku/category/ref/list/" + data.skuCode);
      this.loading = false;
      if (resData.result != 200) return;
      let checkData = []
      resData.data.map(item => {
        checkData.push(item.categoryId)
      })
      this.voucherParams.eventIds = checkData
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    SearchDictionaryList() {
      this.getEquityList()
    },
    /**
     *  get list 分组列表
     */
    async getVipRightList() {
      let http = "/sku/group/list/" + this.$route.query.examId;
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.groupedList = resData.data;
        this.activeGrouping = resData.data[0].id + ''
        this.getEquityList()
      } else {
        this.groupedList = [];
        this.$confirm("当前测评题还没有设置分组，权益设置需要现在设置分组，是否去设置分组?", "提示", {
          type: "info",
        }).then(async () => {
          this.$router.push({name: 'GROUPING', query: {examId: this.$route.query.examId}})
        });
      }
    },
    //获取分组的权益列表
    async getEquityList() {
      let http = "/sku/list/byGroupId/" + this.activeGrouping;
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
    },
    //分组切换
    handleGroupClick() {
      this.getEquityList()
    },
    /**
     * 修改权益状态
     */
    async changeSwitch(data) {
      const {data: resData} = await this.$get(
          `/sku/updateStatus/${data.skuCode}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    //设置排序
    async changOrdered(data) {
      let objData = {
        skuCode: data.skuCode,
        sort: data.sort
      }
      const {data: resData} = await this.$post(
          "/sku/updateSort", objData
      );
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.examCode = this.$route.query.examId
          this.params.parentId = this.activeGrouping
          let b = (this.params.payPrice) * 100
          let c = b.toFixed(1)
          this.params.payPrice = parseInt(c)
          const {data: resData} = await this.$post(
              "/sku/save",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code':this.languageCode
                },
              }
          );
          this.params = resData.data
          this.getEquityInfo()
          this.getEquityList();
        });
      });
    },
    //删除分组
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/sku/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
  border: 0;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}

.cute_img_box {
  width: 30px;
  height: auto;
  object-fit: contain;
  margin-right: 10px;
}

</style>

<style>
/*.role .roleRight_Top .el-button + .el-button {*/
/*  margin-left: 0;*/
/*}*/
</style>
